import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import {
  ForbiddenComponent,
  LoginComponent,
  DlvErrorComponent,
  LogoutComponent,
  SyncPermComponent
} from "@app/core/components";
import { AuthGuardService } from "@app/core/services";

const appRoutes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "login-internal",
    component: LoginComponent
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {
    path: "",
    loadChildren: "app/core/core.module#CoreModule"
  },
  {
    path: "error",
    component: DlvErrorComponent,
    pathMatch: "full"
  },
  {
    path: "forbidden",
    component: ForbiddenComponent
  },
  {
    path: "**",
    redirectTo: ""
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutesModule {}
